import { ColumnInterface } from "../interfaces/column.interface";
import { ModelInterface } from "../interfaces/model.interface";

export class BaseModel {
  static constructors: { [key: string]: any }
  static models: ModelInterface[]

  className: string | undefined
  columns: ColumnInterface[] | undefined

  constructor(...args: any[]) {
  }

}
